module.exports = __webpack_public_path__ + "img/img1.52844403.jpg";